export default "__VITE_ASSET__D_vXHyx7__"